/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="48"
        height="36"
        viewBox="0 0 48 36"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M659.08,387.76c0-13.13,13.15-21.7,15.72-21.7a.78.78,0,0,1,.82.74v.06c0,.94-1.5,1.08-4.92,4.43-3.14,3.08-4.92,6.16-5.06,11.92,1-.14,1.92-.4,2.74-.54a22.89,22.89,0,0,1,2.85-.27c5.47,0,9.7,3,9.7,9.51,0,6.17-4,10-10,10C664.69,402,659.08,396.73,659.08,387.76Zm25.56,0c0-13.13,13.13-21.7,15.72-21.7a.78.78,0,0,1,.82.74v.06c0,.94-1.5,1.08-4.92,4.43-3.14,3.08-4.92,6.16-5,11.92,1-.14,1.92-.4,2.74-.54a23,23,0,0,1,2.87-.27c5.47,0,9.7,3,9.7,9.51,0,6.17-4,10-10,10C690.23,402,684.64,396.73,684.64,387.76Z"
          transform="translate(-659.08 -366.06)"
          className="icon-fill"
          fillRule="evenodd"/>
      </svg>

    );
  }
}

Icon.displayName = 'QuotationMarkDoubleCurvedIcon';

export default Icon;
